// Generated by CoffeeScript 1.12.2
define('etc/pro_feature_block',['require','sp/utilities/has_markdown','sp/utilities/strip_markdown'],function(require) {
  var ProFeatureBlock, hasMarkdown, stripMarkdown;
  hasMarkdown = require('sp/utilities/has_markdown');
  stripMarkdown = require('sp/utilities/strip_markdown');

  /**
  	Managaes the display and functionaliy of all pro features
  
  	@class ProFeatureBlock
   */
  return ProFeatureBlock = (function() {

    /**
    		Name of local storage variable which disables the pro warning modal
    
    		@name DISABLE_PRO_WARNING
    		@value "pro_warning"
    		@static
    		@readOnly
     */

    /**
    		Placeholder for image questions
    
    		@name IMAGE_PLACEHOLDER
    		@value "https://public.surveyplanet.com/images/img_unavailable.png"
    		@static
    		@readOnly
     */
    ProFeatureBlock.IMAGE_PLACEHOLDER = 'https://public.surveyplanet.com/images/img_unavailable.png';


    /**
    		An instacnce of a Backbone Model containing all the survey data
    
    		@property model
    		@type Backbone.Model (Survey)
    		@default null
     */

    ProFeatureBlock.prototype.model = null;


    /**
    		Whether or not the user is pro
    
    		@property proUser
    		@type Boolean
    		@default false
     */

    ProFeatureBlock.prototype.proUser = false;


    /**
    		A list of pro features in use
    
    		@property proUser
    		@type Array
    		@default []
     */

    ProFeatureBlock.prototype.proFeatureList = [];


    /**
    		Whether or not the survey is in preview mode or not
    
    		@property previewMode
    		@type Boolean
    		@default false
     */

    ProFeatureBlock.prototype.previewMode = false;

    ProFeatureBlock.blockProFeatures = function(model, proUser, previewMode) {
      var proFeatureBlock;
      return proFeatureBlock = new ProFeatureBlock(model, proUser, previewMode);
    };

    function ProFeatureBlock(model1, proUser1, previewMode1) {
      this.model = model1;
      this.proUser = proUser1;
      this.previewMode = previewMode1;
      if (!this.proUser) {
        if (this.previewMode) {
          this.buildProFeatureList();
        } else {
          this.blockFeatures();
        }
      }
    }


    /**
    		Removes all the pro features
    
    		@method blockFeatures
    		@return {Object}
     */

    ProFeatureBlock.prototype.blockFeatures = function() {
      this.removeLogo();
      this.updateImageQuestions();
      this.removeComments();
      this.removeTheme();
      this.removeFormating();
      this.removeOpeningImage();
      this.removeClosingImage();
      return this.removeBranches();
    };


    /**
    		Retrieves a list of all the pro features in use
    
    		@method proFeatureList
    		@return {Array}
     */

    ProFeatureBlock.prototype.buildProFeatureList = function() {
      this.proFeatureList = [];
      if (this.model.get('branding').logo) {
        this.proFeatureList.push("Custom logo");
      }
      if (this.model.get('branding').url) {
        this.proFeatureList.push("Survey logo link");
      }
      if (this.model.get('welcome').img) {
        this.proFeatureList.push("Welcome image");
      }
      if (this.model.get('success').img) {
        this.proFeatureList.push("Success image");
      }
      if (this.model.get('success').url) {
        this.proFeatureList.push("Alternative success url");
      }
      if (this.model.get('theme') && this.model.get('theme').pro) {
        this.proFeatureList.push("Pro theme");
      }
      this.model.get('questions').forEach((function(_this) {
        return function(question) {
          if (hasMarkdown(question.title)) {
            _this.proFeatureList.push("Custom formatting on question title");
          }
          if (question.type === 'image') {
            _this.proFeatureList.push("Image question type");
          }
          if (question.comments != null) {
            _this.proFeatureList.push("Additional comments");
          }
          if ((question.branches != null) && question.branches.length) {
            return _this.proFeatureList.push("Question Branches");
          }
        };
      })(this));
      return this.proFeatureList = _.uniq(this.proFeatureList);
    };


    /**
    		Removes comments.
    
    		@method removeComments
     */

    ProFeatureBlock.prototype.removeComments = function() {
      return this.model.get('questions').forEach(function(question) {
        return question.comments = null;
      });
    };


    /**
    		Removes logo and custome url from header.
    
    		@method removeLogo
     */

    ProFeatureBlock.prototype.removeLogo = function() {
      return this.model.set('branding', {});
    };


    /**
    		Removes the image from the welcome screen.
    
    		@method removeOpeningImage
     */

    ProFeatureBlock.prototype.removeOpeningImage = function() {
      return this.model.get('welcome').img = null;
    };


    /**
    		Removes them image from the success screen.
    
    		@method removeClosingImage
     */

    ProFeatureBlock.prototype.removeClosingImage = function() {
      return this.model.get('success').img = null;
    };


    /**
    		Removes text formtating from the questions.
    
    		@method removeFormating
     */

    ProFeatureBlock.prototype.removeFormating = function() {
      return this.model.get('questions').forEach(function(question) {
        if ((question.title != null) && question.title.length) {
          question.title = stripMarkdown(question.title).trim();
        }
        if ((question.subtitle != null) && question.subtitle.length) {
          return question.subtitle = stripMarkdown(question.subtitle).trim();
        }
      });
    };


    /**
    		Removes the images from image question types
    
    		@method updateImageQuestions
     */

    ProFeatureBlock.prototype.updateImageQuestions = function() {
      return this.model.get('questions').forEach(function(question) {
        if (question.type === 'image') {
          question.properties.hideCaptions = false;
          question.properties.size = 'medium';
          return _.map(question.properties.labels, function(label) {
            return label.image = ProFeatureBlock.IMAGE_PLACEHOLDER;
          });
        }
      });
    };


    /**
    		Removes all the theme styles.
    
    		@method removeTheme
     */

    ProFeatureBlock.prototype.removeTheme = function() {
      if (this.model.get('theme') && this.model.get('theme').pro) {
        return this.model.set('theme', null);
      }
    };


    /**
    		Removes all the branches from questions.
    
    		@method removeBranches
     */

    ProFeatureBlock.prototype.removeBranches = function() {
      return this.model.get('questions').forEach(function(question) {
        return question.branches = null;
      });
    };

    return ProFeatureBlock;

  })();
});

